import { render } from "./Principal-sidebar.vue?vue&type=template&id=d235d6be"
import script from "./Principal-sidebar.vue?vue&type=script&lang=js"
export * from "./Principal-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__